import { useEffect, useState } from "react";
import { ISelectOption } from "../components/UI/SelectInput/types";
import dayjs from "dayjs";

function useMonthYear(minYear: number = 2014, today: dayjs.Dayjs = dayjs()) {
  const [month, setMonth] = useState<string | number>(today.get("month").toString());
  const [year, setYear] = useState<string>(today.get("year").toString());
  const [years, setYears] = useState<ISelectOption[]>([]);

  const isMonthEmpty = month === "";
  const isYearEmpty = year === "";

  useEffect(() => {
    const currentYear = today.get("year");
    const years = currentYear - minYear;

    for (let year = 0; year <= years; year++) {
      const yearDecreased = currentYear - year;

      setYears((prevYears) => {
        prevYears.push({
          name: yearDecreased.toString(),
          value: yearDecreased.toString(),
        });

        return [...prevYears];
      });
    }
  }, []);

  return {
    month,
    year,
    years,
    isMonthEmpty,
    isYearEmpty,
    setMonth,
    setYear,
  };
}

export default useMonthYear;
